import React from 'react';
import {
  Button,
  Grid,
  Alert,
  CircularProgress
} from '@mui/material';
import BaseDialog from '../common/BaseDialog';
import CustomerDetailsCard from '../common/CustomerDetailsCard';
import JobForm from '../common/JobForm';
import { UpdateJobDto } from '../../services/jobService';
import { Customer } from '../../services/customerService';
import { Business } from '../../services/businessService';

interface JobEditDialogProps {
  open: boolean;
  onClose: () => void;
  onUpdate: () => void;
  job: any;
  customer: Customer | null;
  business: Business | null;
  formData: UpdateJobDto;
  onFormDataChange: (data: Partial<UpdateJobDto>) => void;
  error: string | null;
  success: string | null;
}

const JobEditDialog: React.FC<JobEditDialogProps> = ({
  open,
  onClose,
  onUpdate,
  customer,
  business,
  formData,
  onFormDataChange,
  error,
  success
}) => {
  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      title="Edit Job"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          maxWidth: { xs: 'calc(100vw - 10px)', sm: '900px' }
        }
      }}
      contentSx={{ pb: 4 }}
      actions={
        <>
          <Button
            onClick={onClose}
            variant="outlined"
            color="primary"
          >
            Cancel
          </Button>
          <Button onClick={onUpdate} variant="contained">Update</Button>
        </>
      }
    >
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
      <Grid container spacing={2} sx={{ mt: 1 }}>
        {customer && (
          <Grid item xs={12}>
            <CustomerDetailsCard
              customer={customer}
              title="Customer Details"
            />
          </Grid>
        )}
        <JobForm
          formData={formData}
          onFormDataChange={onFormDataChange}
          defaultBounds={{
            city: business?.defaultCity,
            country: business?.defaultCountry
          }}
          showCustomerSelection={false}
        />
      </Grid>
    </BaseDialog>
  );
};

export default JobEditDialog;
